import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BusinessIcon(props: IconProps) {
    return <Icon {...props} iconKey={"business"}/>
}
